import React, { useEffect, useRef } from 'react';
import { Dimensions, KeyboardAvoidingView, Platform } from 'react-native';


import RBSheet from "react-native-raw-bottom-sheet";

import tw from '../styles/tailwind';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

//! TODO: RBSheet tiene 4 años, buscar sustituir pore esta https://github.com/stanleyugwu/react-native-bottom-sheet


export default function BottomSheet(props) {
  const refRBSheet = useRef();
  const insets = useSafeAreaInsets();
  const deviceDimensions = Dimensions.get('screen')

  useEffect(() => {
    if (props.visible)
      refRBSheet.current.open()
    else
      refRBSheet.current.close()
  }, [props.visible])


  useEffect(() => {
    if (props.visible)
      refRBSheet.current.open()
  }, [props.height])


  return (
    <RBSheet
      ref={refRBSheet}
      height={props.height}
      openDuration={250}
      onClose={props.onRequestClose}
      customStyles={{
        container: tw.style(
          `rounded-tl-3xl rounded-tr-3xl`,
          {
            paddingBottom: insets.bottom,
            paddingTop: insets.top + props.height >= deviceDimensions.height ? insets.top : 0 ,
          },
          {
            // En web el sheet ocupaba todo el ancho; lo limitamos y centramos.
            // En móvil (ancho < 560) el maxWidth no tiene efecto.
            maxWidth: 560,
            width: '100%',
            alignSelf: 'center',
            // justifyContent: "center",
            // alignItems: "center",
            // height: 'auto',
            // maxHeight: 600,
            // flexGrow: 1,
            // flex: 1,
            // paddingHorizontal: 30,
            ...props.style?.container,
          }),
      }}
    >
      <KeyboardAvoidingView
        behavior="padding"
        style={tw`flex-1`}
      >
        {props.children}
      </KeyboardAvoidingView>
    </RBSheet>
  )
}